// extracted by mini-css-extract-plugin
export default {"row":"classes_row__fooXj","left":"classes_left__40BkH","nftImage":"classes_nftImage__Ddqci","color":"classes_color__ysMgF"};